export default "https://storage.googleapis.com/prepweb-prod/dist/4ae879dafaed93ce25f7bdd297239e5d.svg";